export function makeTopic(initialState, observers) {
    return {
        _state: initialState,
        _observers: observers || [],
        add: function (observer) {
            this._observers.push(observer);
        },
        getState: function () {
            return this._state
        },
        setState: function (value) {
            this._state = value;
            for (let i = 0; i < this._observers.length; i++) {
                this._observers[i].signal(this)
            }
        }
    }
}

export function makeObserver(callback) {
    return {
        signal: callback
    }
}